import type {
  AIService,
  ChatOptions,
  ChatRequest,
  ChatResponse,
  ChatStreamChunk,
} from '../../ports/ai'
import { parseSse, type Transport } from './transport'

export class HttpAIService implements AIService {
  constructor(private readonly t: Transport) {}

  chat(req: ChatRequest, opts?: ChatOptions): Promise<ChatResponse> {
    return this.t.json<ChatResponse>('POST', '/v1/chat', { body: req, signal: opts?.signal })
  }

  async *stream(req: ChatRequest, opts?: ChatOptions): AsyncIterable<ChatStreamChunk> {
    const res = await this.t.request('POST', '/v1/chat/stream', {
      body: { ...req, stream: true },
      signal: opts?.signal,
      headers: { Accept: 'text/event-stream' },
    })
    for await (const data of parseSse(res)) {
      if (data === '[DONE]') return
      yield JSON.parse(data) as ChatStreamChunk
    }
  }
}
